import React, { FC } from 'react'
import { Shared } from 'ui/shared'
import Grid from '@mui/material/Grid'
import { Form } from 'utils/helpers/form'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { useForm, useWatch } from 'react-hook-form'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_Trailers } from 'redux/modules/trailers/Actions'

interface IForm {
  leasingCompanyId: number
}

export const CsvFileLeasing: FC = () => {
  const { t } = useTranslation(I18nModal.csvFileLeasing)
  const dispatch = useDispatch()

  const leasingCompanies = useSelector((state: TState) => state.trailers.leasingCompanies, shallowEqual)

  const { handleSubmit, errors, control } = useForm<IForm>()

  const leasingCompanyId = useWatch({
    control,
    name: 'leasingCompanyId',
  })

  const onSubmit = (formData: IForm) => {
    dispatch(Actions_Trailers.saga.getTrailersLeasingCsv({ leasingCompanyId: formData.leasingCompanyId }))
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  const options = leasingCompanies.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.id,
  }))

  return (
    <Shared.Card style={{ width: 375 }}>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Shared.CardTitle title={t('title')} />
          </Grid>

          <Grid item xs={12}>
            <Shared.AutocompleteForForm
              name="leasingCompanyId"
              label={t('leasingCompany')}
              options={options}
              control={control}
              rules={Form.required}
              error={errors.leasingCompanyId?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.Button
              style={{ margin: '2em 0 0.875em 0' }}
              color={'secondary'}
              title={t('cancel')}
              onClick={closeModal}
            />
            <Shared.Button title={t('download')} type={'submit'} disabled={!leasingCompanyId} />
          </Grid>
        </Grid>
      </form>
    </Shared.Card>
  )
}
